import React from 'react';

import { Tooltip } from '@mui/material';

import { type TPermission, usePermission } from '../pages/platforms/PlatformSettingsPage/hooks';

type Props = {
  name: TPermission;
  children: JsxNode;
  span?: boolean;
};

export default function PermissionTooltip({ name, children, span }: Props) {
  const permission = usePermission(name);
  if (permission) {
    return children;
  }
  if (!span) {
    return (
      <Tooltip title={getTooltipTitle(name)}>
        <>{children}</>
      </Tooltip>
    );
  }
  return (
    <Tooltip title={getTooltipTitle(name)}>
      <span>{children}</span>
    </Tooltip>
  );
}

function getTooltipTitle(name: TPermission) {
  switch (name) {
    case 'updateSubscription':
      return `You don't have permission to modify the billing information.`;
    case 'updatePlatformInformation':
      return `You don't have permission to modify the workspace information.`;
    case 'createVerifiedDomain':
      return `You don't have permission to create verified domains.`;
    case 'createVerifiedEmailAddress':
      return `You don't have permission to create approved senders.`;
    case 'invitePlatformUser':
      return `You don't have permission to modify teammates.`;
    case 'createApiKey':
      return `You don't have permission to create API keys.`;
    default:
      return `You don't have permission to perform this action.`;
  }
}
